import { forwardRef, type LegacyRef } from 'react';
import { useParams } from 'react-router-dom';
import assert from 'assert';
import { useAppSelector } from '../../../store/hooks';
import StateDecorator from '../../../components/utils/state/StateDecorator';
import { isDataState } from '../../../store/data/state';
import ManagementDecorator from '../ManagementDecorator';
import { getOrElse } from '../../../utils/functions';
import type { ApiReturnRole } from '@highimpact-frontend/api-types';

function getInstanceById<T extends { id: number }>(
  data: Record<number, T>,
  id: number
): T | undefined {
  return data[id];
}

function User(_: object, ref: LegacyRef<HTMLDivElement>): JSX.Element {
  const params = useParams();
  //TODO: Au lieux d'un assert afficher une erreur.
  assert(params['user_id']);
  const userId = Number.parseInt(params['user_id']);

  const users = useAppSelector((state) => state.data_slice.externals.users);

  const roles = useAppSelector((state) => state.data_slice.externals.roles);

  return ManagementDecorator(ref, () =>
    StateDecorator([roles, users], ref, () => {
      assert(isDataState(users));
      assert(isDataState(roles));

      const user = getInstanceById(users.data, userId);

      if (user === undefined) return <div>Erreur : Projet non trouvé</div>;

      const headings = [
        'Nom' as const,
        'Email' as const,
        'Téléphone' as const,
        'Role' as const,
      ];
      type FormattedKey = (typeof headings)[number];
      type Formatted = { [key in FormattedKey]: string };
      const formatted: Formatted = {
        Nom: getOrElse(user.name),
        Email: getOrElse(user.email),
        Téléphone: getOrElse(user.tel),
        Role: getOrElse(
          Object.values(roles.data).find(
            (role: ApiReturnRole) => role.id === user.role_id
          )?.name
        ),
      };
      return (
        <table className="uk-table uk-table-divider">
          <tbody>
            {Object.entries(formatted).map(([key, val]) => (
              <tr>
                <th style={{ width: '25%', textAlign: 'right' }}>{key}</th>
                <td>{val}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    })
  );
}

export default forwardRef(User);
